import React, {useEffect, useMemo, useRef, useState} from "react";
import * as PropTypes from "prop-types";
import classNames from "classnames";
import {useDispatch} from "react-redux";
import {changeBurger, changeFilter, usePanel} from "../../../../redux/reducer/panel";
import {useRouter} from "next/router";
import styles from "./CustomMenu.module.scss";


export default function CustomMenuItem(props) {
  const [menuCategory, setMenuCategory] = useState(null);
  const dispatch = useDispatch();
  const router = useRouter()
  const {filter} = usePanel()
  const itemRef = useRef()


  const insidePage = props.href === filter


  const isMain = props.href === '' && !router.query.page && !router.query.aId
  const active = useMemo(() => props.href === menuCategory, [menuCategory])


  useEffect(() => {
    // Ищем метатег с атрибутом name="menuCategory"
    const metaTag = document.querySelector('meta[name="menuCategory"]');

    // Если метатег найден, извлекаем значение атрибута content
    if (metaTag) {
      setMenuCategory(metaTag.getAttribute('content'));
    }
  }, [router.query]);

  // useEffect(() => {
  //   console.log(menuCategory, 'MenuCategory')
  // }, [menuCategory])

  useEffect(() => {
    if (active) {
      props.setActiveItem(itemRef.current)
    }
  }, [active]);

  return (
    <li ref={itemRef}
        className={classNames(styles.customMenu__item, {
          [props.className]: props.className,
          [styles.customMenu__item_active]: active
        })} {...props.attr}
        onClick={() => {
          router.push('/' + props.href)
          dispatch(changeFilter(props.href));
          dispatch(changeBurger(false));
        }}
    >
      {props.text}
    </li>
  )
}

CustomMenuItem.propTypes = {
  className: PropTypes.string,
  attr: PropTypes.object,
  href: PropTypes.string,
  text: PropTypes.string,
};
